import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar';
import Contact from '../Contact';
import { useNavigate } from "react-router-dom";

const ProductPortfolio = () => {
  const navigate = useNavigate();
  const products = [
    { 
      id: "1",
      name: 'FoodTech Pro', 
      domain: 'Food & Beverage',
      keywords: ['Fresh', 'Organic', 'Healthy', 'Delicious'],
      media: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80',
      type: 'image'
    },
    { 
      id: "2",
      name: 'Smart Transport', 
      domain: 'Automotive & Mobility',
      keywords: ['Fast', 'Efficient', 'Safe', 'Modern'],
      media: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800&q=80',
      type: 'image'
    },
    { 
      id: "3",
      name: 'EcoHome', 
      domain: 'Real Estate & Architecture',
      keywords: ['Sustainable', 'Green', 'Smart', 'Future'],
      media: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
      type: 'image'
    },
    { 
      id: "4",
      name: 'HealthCare+', 
      domain: 'Healthcare & Medical',
      keywords: ['Medical', 'Care', 'Wellness', 'Life'],
      media: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=800&q=80',
      type: 'image'
    },
    { 
      id: "5",
      name: 'EduTech', 
      domain: 'Education & Learning',
      keywords: ['Learning', 'Knowledge', 'Growth', 'Innovation'],
      media: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&q=80',
      type: 'image'
    },
    { 
      id: "6",
      name: 'FinTech Suite', 
      domain: 'Finance & Banking',
      keywords: ['Banking', 'Secure', 'Digital', 'Fast'],
      media: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80',
      type: 'image'
    },
    { 
      id: "7",
      name: 'Fashion AI', 
      domain: 'Fashion & Retail',
      keywords: ['Style', 'Trendy', 'Elegant', 'Chic'],
      media: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80',
      type: 'image'
    },
    { 
      id: "8",
      name: 'Sports Tech', 
      domain: 'Sports & Fitness',
      keywords: ['Fitness', 'Performance', 'Active', 'Strong'],
      media: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80',
      type: 'image'
    }
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #ffffff 0%, #f5f7fa 50%, #e8ecf1 100%)',
      minHeight: '100vh'
    }}>
      <Navbar />
      
      {/* Hero Section */}
      <div className="container-fluid" style={{ height: '100vh', overflow: 'hidden' }}>
        <div className="row h-100">
          <div className="col-lg-6 d-flex align-items-center" style={{ padding: '60px' }}>
            <div>
              <h1 style={{ 
                fontSize: '4rem', 
                fontWeight: '700', 
                marginBottom: '30px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Our Product Portfolio
              </h1>
              <p style={{ 
                fontSize: '1.3rem', 
                lineHeight: '1.8', 
                color: '#4a5568',
                marginBottom: '30px'
              }}>
                Explore our diverse range of digital products crafted to empower industries and redefine innovation. 
                From smart automation to creative intelligence, each solution embodies our commitment to excellence.
              </p>
              <button style={{
                padding: '15px 40px',
                fontSize: '1.1rem',
                border: 'none',
                borderRadius: '50px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#fff',
                cursor: 'pointer',
                transition: 'transform 0.3s ease',
                boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              >
                Explore Products
              </button>
            </div>
          </div>
          <div className="col-lg-6 d-flex align-items-center justify-content-center" style={{ position: 'relative', padding: '40px' }}>
            <div style={{ 
              width: '100%', 
              height: '80%',
              maxWidth: '600px',
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)'
            }}>
              <img 
                src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80"
                alt="Technology Innovation"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="container-fluid" style={{ padding: '60px 40px' }}>
        {[0, 1, 2, 3].map((rowIdx) => (
          <div className="row mb-5" key={rowIdx}>
            {products.slice(rowIdx * 2, rowIdx * 2 + 2).map((product, colIdx) => {
              const productIdx = rowIdx * 2 + colIdx;
              return (
                <div className="col-lg-6 mb-4" key={productIdx} onClick={() => navigate(`/portfolio-details/${product.id}`)}>
                  <div style={{
                    position: 'relative',
                    borderRadius: '20px',
                    overflow: 'hidden', 
                    background: 'transparent',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                    height: '450px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-10px)';
                    e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 0, 0, 0.1)';
                  }}
                  >
                    <img 
                      src={product.media}
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '450px',
                        objectFit: 'cover'
                      }}
                    />
                    
                    {/* Animated Keywords Bar */}
                    <div style={{
                      position: 'absolute',
                      top: '380px',
                      left: '0',
                      right: '0',
                      background: 'transparent',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 0',
                      overflow: 'hidden',
                      borderTop: '1px solid rgba(0, 0, 0, 0.1)'
                    }}>
                      <div style={{
                        display: 'flex',
                        animation: 'scroll 15s linear infinite',
                        whiteSpace: 'nowrap'
                      }}>
                        {[...product.keywords, ...product.keywords, ...product.keywords].map((keyword, idx) => (
                          <span key={idx} style={{
                            padding: '0 30px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            color: 'black',
                            textTransform: 'uppercase',
                            letterSpacing: '2px'
                          }}>
                            {keyword} •
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    {/* Project Name Badge */}
                    <div style={{
                      position: 'absolute',
                      top: '20px',
                      left: '20px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      padding: '8px 15px',
                      borderRadius: '50px',
                      fontSize: '1rem',
                      fontWeight: '600',
                      color: '#fff',
                      boxShadow: '0 5px 15px rgba(102, 126, 234, 0.4)'
                    }}>
                      {product.name}
                    </div>
                  </div>
                  <div style={{
                      padding: '20px 20px',
                      background: 'transparent'
                    }}>
                      <h3 style={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        color: '#2d3748',
                        marginBottom: '5px'
                      }}>
                        {product.name}
                      </h3>
                      <p style={{
                        fontSize: '1rem',
                        color: '#718096',
                        margin: 0,
                        fontWeight: '500'
                      }}>
                        {product.domain}
                      </p>
                    </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
      <Contact />

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }
        
        body {
          margin: 0;
          padding: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
        }
      `}</style>
    </div>
  );
};

export default ProductPortfolio;
